export function scrollToElem(elemId) {
  const navOffset = 140;
  const scrollTarget = document.getElementById(elemId).getBoundingClientRect();
  const scrollTargetX =
    scrollTarget.top + document.documentElement.scrollTop - navOffset;
  window.scrollTo({ top: scrollTargetX});
}
